import { computed, type ComputedRef } from 'vue'

import useBreakpoints from './useBreakpoints'

export interface BreakpointsValueOptions<T> {
  tablet?: T
  desktop?: T
}

const useBreakpointsValue = <T> (defaultValue: T, resposiveValues?: BreakpointsValueOptions<T>): ComputedRef<T> => {
  const { isTabletSize, isDesktopSize } = useBreakpoints()

  return computed<T>(() => {
    if (isDesktopSize.value && resposiveValues?.desktop !== undefined) {
      return resposiveValues.desktop
    } else if (isTabletSize.value && resposiveValues?.tablet !== undefined) {
      return resposiveValues.tablet
    } else {
      return defaultValue
    }
  })
}

export default useBreakpointsValue
